/**
 * 参考HTML
	<div class="js-accordion">
		<button class="js-accordion-trigger" type="button">
			<span class="title">
				# title
			</span>
		</button>

		<div class="js-accordion-target">
			<div class="body">
				# contants
			</div>
		</div>
	</div>

 * 	Accordion({
 *		base: ".js-accordion",
 *		trigger: ".js-accordion-trigger",
 *		target: ".js-accordion-target",
 *	});
 */

/**
 * @param {Object} Options
 * @param {String} Options.base - アコーディオンの親要素を指定
 * @param {String} Options.trigger - アコーディオンのトリガー要素を指定
 * @param {String} Options.target - アコーディオンのターゲット要素を指定
 * @param {Boolean} [Options.option=true] - trueの場合ターゲット要素以外をクリックした場合に閉じる
 */

export default function Accordion({ base, trigger, target, option = true }) {
	const getEventType = window.ontouchstart ? 'touchstart' : 'click';
	const baseElement = document.querySelectorAll(base);

	if (baseElement.length === 0) {
		console.error(`${base}が見つかりませんでした`);
		return;
	}

	baseElement.forEach((el) => {
		const triggerElement = el.querySelector(trigger);
		const targetElement = el.querySelector(target);

		if (!triggerElement || !targetElement) {
			console.error(`${trigger}か${target}が見つかりませんでした`);
			return;
		}

		triggerElement.addEventListener(getEventType, () => {
			if (!el.classList.contains('is-show')) {
				const bodyHeight =
					targetElement.firstElementChild?.clientHeight;
				targetElement.setAttribute('style', `height: ${bodyHeight}px;`);
				el.classList.add('is-show');
				return;
			}

			el.classList.remove('is-show');
			targetElement.setAttribute('style', 'height: 0px;');
		});

		if (option) {
			document.addEventListener(getEventType, (e) => {
				if (el.classList.contains('is-show')) {
					if (e.target !== triggerElement) {
						el.classList.remove('is-show');
						targetElement.setAttribute('style', 'height: 0px;');
						return;
					}
				}
			});
		}
	});
}
